import globalMU from "globalMU";
import React from "react"

const estiloNotasFicaisPendentes = require("./notas-fiscais-pendentes.module.scss").default;
const estiloTabela = require('../../../../estilos/tabelas.module.scss').default

export type NotasFiscaisPendentes = {
    NumeroNota: string
    SerieNota: string
    CodigoProduto: string
    Quantidade: number
    DataPrevisaoEntrega: string
    RazaoSocial: string
}

export type NotasFiscaisPendentesProps = {
    produto: string;
    descricao: string;
    dados: NotasFiscaisPendentes[];
    orcamentoMascaraQuantidade: string;
};

export const NotasFiscaisPendentes = (props: NotasFiscaisPendentesProps) => {
    
    const numeroCasasDecimaisQuantidade = globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(props.orcamentoMascaraQuantidade, 3)

    const descricaoProdutoSelecionado = (
        <div className={estiloNotasFicaisPendentes.InformacoesProduto}
          id="NotasFiscaisPendentes_descricaoProdutoSelecionado"
        >
          <div className={estiloNotasFicaisPendentes.primeiraColuna}>Produto</div>
          <div style={{ marginTop: "7px" }}>{props.produto}</div>
          <div className={estiloNotasFicaisPendentes.primeiraColuna}>Descrição</div>
          <div style={{ marginTop: "7px" }}>{props.descricao}</div>
        </div>
      );

    const tableHead = <div className="_table-row">
        <div className={`_table-cell ${estiloNotasFicaisPendentes.tableCellHeader}`}>
            Nota Fiscal
        </div>
        <div className={`_table-cell ${estiloNotasFicaisPendentes.tableCellHeader}`}>
            Série
        </div>
        <div className={`_table-cell _text-center ${estiloNotasFicaisPendentes.tableCellHeader}`}>
            Quantidade
        </div>
        <div className={`_table-cell _text-center ${estiloNotasFicaisPendentes.tableCellHeader}`}>
            Data Previsão Entrega
        </div>
        <div className={`_table-cell ${estiloNotasFicaisPendentes.tableCellHeader}`}>
            Cliente
        </div>
    </div>

    const tableBody = props.dados.map((dado, index) => {
        return <div key={index} className={`_table-row ${estiloNotasFicaisPendentes.linha}`}>
            <div className={`_table-cell  ${estiloNotasFicaisPendentes.tableCellBody}`}>
                {dado.NumeroNota}
            </div>
            <div className={`_table-cell  ${estiloNotasFicaisPendentes.tableCellBody}`}>
                {dado.SerieNota}
            </div>
            <div className={`_table-cell _text-center  ${estiloNotasFicaisPendentes.tableCellBody}`}>
            {globalMU.formatarValorNumerico(dado.Quantidade, numeroCasasDecimaisQuantidade, false)}
            </div>
            <div className={`_table-cell _text-center ${estiloNotasFicaisPendentes.tableCellBody}`}>
            {globalMU.formatDate(dado?.DataPrevisaoEntrega)}
            </div>
            <div className={`_table-cell  ${estiloNotasFicaisPendentes.tableCellBody}`}>
                {dado.RazaoSocial}
            </div>
        </div>
    })

    const quantidadeTotal = () => {
        const quantidadeNaoEntregueTotal = () => {
            let total = 0
            props.dados?.forEach((x) => total += x.Quantidade)
            return total
        }
        
        return <div>
                <div className="_text-lg _font-bold _text-blue-500 _mb-4">Totais</div>

                <div className={estiloNotasFicaisPendentes.quantidadeTotal}>
                    <label>Quantidade</label>
                    <div>{globalMU.formatarValorNumerico(quantidadeNaoEntregueTotal(), numeroCasasDecimaisQuantidade, false)}</div>
                </div>
            </div>
    }    

    return (
        <>
            {descricaoProdutoSelecionado}
            <br />
            <div className={estiloTabela.containerRolavel}>
                <div className={`_table _w-full _border-collapse ${estiloNotasFicaisPendentes.table}`}>
                    <div className="_table-header-group">
                        {tableHead}
                    </div>
                    <div className="_table-row-group">
                        {tableBody}
                    </div>
                </div>
            </div>
            <br />
            {quantidadeTotal()}
        </>
    )
}